angular.module('account').controller('CreateAccountCtrl',
    ['$scope', '$state',
        function () {
            'use strict';
        }]);


